import script from "./GlobalMixins.vue?vue&type=script&lang=js"
export * from "./GlobalMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__